import { render } from "./ProductEditHost.vue?vue&type=template&id=b27a526c"
import script from "./ProductEditHost.vue?vue&type=script&lang=js"
export * from "./ProductEditHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__